





import Vue from 'vue'
import MarkdownIt from 'markdown-it'

export default Vue.extend({
  props: {
    markdownContent: {
      type: String,
      required: true
    }
  },
  computed: {
    htmlContent(): string {
      const markdownIt = new MarkdownIt({ html: true })
      return markdownIt.render(this.markdownContent)
    }
  }
})
